import styled from "styled-components";

import { bp, media } from "@styles/Utilities.styled";


export const Container = styled.div`
  width: 90%;
  margin: 0 auto;
  height: 100%;

  ${media(bp.medium)} {
    width: 95%;
  }
`;
